// Los 3 gestos de movimiento del rediseño Decantorino, compartidos por el home y la ficha.
// 1 · el titular se sirve palabra por palabra y traza su línea vino
// 2 · las escenas se descubren por cortina
// 3 · profundidad sutil por scroll
// Extra con función: la cuenta de los packs se hace sola al entrar en pantalla.
(function(){
  var calma = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // sin este script nada se esconde: el estado inicial vive detrás de .js-mov
  document.documentElement.classList.add('js-mov');

  document.querySelectorAll('.titular').forEach(function(titular){
    var retraso = 0;
    [].slice.call(titular.childNodes).forEach(function(nodo){
      var texto = nodo.textContent;
      if(!texto.trim()){ return }
      var esEnfasis = nodo.nodeType === 1 && nodo.tagName === 'EM';
      var envoltorio = document.createElement('span');
      texto.trim().split(/\s+/).forEach(function(palabra){
        var caja = document.createElement('span');
        caja.className = 'pal';
        var dentro = document.createElement('span');
        dentro.textContent = palabra;
        retraso += 60;
        dentro.style.transitionDelay = retraso + 'ms';
        caja.appendChild(dentro);
        envoltorio.appendChild(caja);
        envoltorio.appendChild(document.createTextNode(' '));
      });
      if(esEnfasis){
        var enfasis = document.createElement('em');
        enfasis.appendChild(envoltorio);
        enfasis.style.setProperty('--traza', (retraso + 120) + 'ms');
        titular.replaceChild(enfasis, nodo);
      } else {
        titular.replaceChild(envoltorio, nodo);
      }
    });
  });

  var animables = [].slice.call(document.querySelectorAll('.reveal,.revela,.titular'));
  var capas = [].slice.call(document.querySelectorAll('.parallax'));
  var contadores = [].slice.call(document.querySelectorAll('[data-cuenta]'));

  if(calma){
    animables.forEach(function(el){ el.classList.add('in') });
    contadores.forEach(function(m){ m.textContent = 'S/ ' + parseFloat(m.dataset.cuenta).toFixed(2) });
  } else {
    // un solo recorrido por scroll para revelar y para la profundidad: si el
    // IntersectionObserver no dispara (pestaña en segundo plano, navegador viejo),
    // el contenido igual aparece en cuanto entra en pantalla
    var pendiente = false;
    var revisar = function(){
      pendiente = false;
      var alto = window.innerHeight;
      animables = animables.filter(function(el){
        if(el.getBoundingClientRect().top > alto * 0.9){ return true }
        el.classList.add('in');
        return false;
      });
      capas.forEach(function(capa){
        var caja = capa.getBoundingClientRect();
        if(caja.bottom < 0 || caja.top > alto){ return }
        var avance = (caja.top + caja.height / 2 - alto / 2) / alto;
        // el scale acompaña al desplazamiento para que nunca asome el borde de la figura
        capa.style.transform = 'translate3d(0,' + (avance * -22).toFixed(1) + 'px,0) scale(1.06)';
      });
      contadores = contadores.filter(function(marcador){
        if(marcador.getBoundingClientRect().top > alto * 0.85){ return true }
        contar(marcador);
        return false;
      });
    };
    var pedirRevision = function(){
      // requestAnimationFrame queda en pausa cuando la pestaña está en segundo plano:
      // ahí se revisa de inmediato para que nada se quede escondido
      if(document.hidden){ revisar(); return }
      if(!pendiente){ pendiente = true; requestAnimationFrame(revisar) }
    };
    addEventListener('scroll', pedirRevision, {passive: true});
    addEventListener('resize', pedirRevision);
    addEventListener('load', pedirRevision);
    addEventListener('visibilitychange', pedirRevision);
    revisar();
  }

  function contar(marcador){
    var destino = parseFloat(marcador.dataset.cuenta);
    var desde = parseFloat(marcador.dataset.desde);
    var inicio = null, duracion = 900;
    // el precio final nunca depende de la animación: si rAF no corre, se escribe igual
    marcador.textContent = 'S/ ' + destino.toFixed(2);
    if(document.hidden){ return }
    var paso = function(ahora){
      if(!inicio){ inicio = ahora }
      var avance = Math.min((ahora - inicio) / duracion, 1);
      var suave = 1 - Math.pow(1 - avance, 3);
      marcador.textContent = 'S/ ' + (desde + (destino - desde) * suave).toFixed(2);
      if(avance < 1){ requestAnimationFrame(paso) }
    };
    requestAnimationFrame(paso);
  }
})();
